import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { fetchContacts } from '../../redux/ducks/contacts';
import Contact from '../../models/Contact';
import Loading from './Loading';

class ContactLink extends Component {
  componentDidMount() {
    const { isFetching, fetched, getContacts } = this.props;

    if (!fetched && !isFetching) {
      getContacts();
    }
  }

  render() {
    const { contactId, contactsById, fetched } = this.props;

    if (!fetched) {
      return <Loading mini />;
    }

    if (!contactId) {
      return null;
    }

    const contact = contactsById[contactId];

    return <Link to={`/contacts/${contactId}`}>{contact.name}</Link>;
  }
}

ContactLink.propTypes = {
  contactId: PropTypes.string,
  contactsById: PropTypes.objectOf(PropTypes.instanceOf(Contact)).isRequired,
  isFetching: PropTypes.bool.isRequired,
  fetched: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Date)]).isRequired,
  getContacts: PropTypes.func.isRequired,
};

ContactLink.defaultProps = {
  contactId: '',
};

function mapStateToProps(state) {
  const {
    contacts: { itemsById, isFetching, fetched },
  } = state;

  return {
    contactsById: itemsById,
    isFetching,
    fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getContacts: () => {
      dispatch(fetchContacts());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactLink);



// WEBPACK FOOTER //
// ./src/components/common/ContactLink.jsx